<template>
    <v-radio-group v-model="value" hide-details inline>
        <v-radio class="mr-16" v-for="index in number" :key="index" :value="`${index}`" color="green" :label="`Alternativa ${altsName[index]}`" />
    </v-radio-group>
    <div style="color: rgb(176,0,32); font-size: 12px; margin-left: 4px;">{{ errorMessage }}</div>
</template>

<script setup>
import { useField } from 'vee-validate';

const altsName  = ['', 'A', 'B', 'C', 'D', 'E'];
const props     = defineProps({
    name: String,
    number: Number, 
});

// The `name` is returned in a function because we want to make sure it stays reactive
// If the name changes you want `useField` to be able to pick it up
const { value, errorMessage } = useField(() => props.name);
</script>